module.exports = __webpack_public_path__ + "static/about-01142835027ed21d551128444ff6d5a0.svg";